import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { ruRU } from "@mui/material/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";

import HighlightOffIcon from "@mui/icons-material/HighlightOff";

import { useEffect } from "react";

export default function Asynchronous({
  childToParent,
  clear,
  dataRows,
  field,
  value2,
  name,
  sx,
  childToParent_id,
  freesl,
  dataParentToChild,
}) {
  const theme = createTheme(ruRU);

  const [value, setValue] = React.useState(value2 !== undefined && value2?.length > 1 ? value2 : "");
  const [inputValue, setInputValue] = React.useState(value2 !== undefined && value2 > 1 ? value2 : "");

   useEffect(() => {
    if (dataRows?.length === 0 && clear === true && (value2 === undefined || (value2 !== undefined && value2.length === 0))) {

      setValue("");
      setInputValue("");
    }
  }, [clear, dataRows, freesl, value2]);

  useEffect(() => {
    if (value2 !== undefined && value2.length > 0) {
            
    //  console.log(" seEffect(() => value2 = " + value2.length);

      setValue(value2);
      setInputValue(value2);
    }
  }, [value2], );



  return (
    <ThemeProvider theme={theme}>

      <Autocomplete
        value={clear === false ? value : ""}
        onChange={(event, newValue) => {
          //console.log(newValue)
          setValue(newValue);
          childToParent_id(newValue);
          //console.log(newValue.id);
        }}
        inputValue={clear === false ? inputValue : ""}
        
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
          childToParent(newInputValue);
        }}
        freeSolo={freesl}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        id="free-solo-2-demo"
        disableClearable
        options={dataRows}
        sx={sx}
        renderOption={(props, option) => {
          return (
            <li
              style={{ height: "40px", left: "15px", top: "10px" }}
              {...props}
              key={option.id}
            >
              {option[field]}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={name}
            InputProps={{
              ...params.InputProps,
              type: "text",

              startAdornment: (
                <InputAdornment
                  position="start"
                  onClick={() => {
                    setInputValue("");
                    setValue("");
                    childToParent_id("");
                    childToParent("");
                  }}
                >
                  <SearchIcon />
                </InputAdornment>
              ),

              endAdornment: value && (
                <IconButton
                  aria-label="toggle password visibility"
                  sx={{
                    position: "absolute",
                    right: "10px",
                  }}
                  onClick={() => {
                    setInputValue("");
                    setValue("");
                    childToParent_id("");
                    childToParent("");
                  }}
                >
                  <HighlightOffIcon
                    sx={{ position: "absolute", right: "10px" }}
                  />
                </IconButton>
              ),
            }}
          />
        )}
      />
    </ThemeProvider>
  );
}
